import { isAdminSite } from '~/utils';

import AdminNavigation from './Layout/Admin';
import LearnerNavigation from './Layout/Learner';

const NavigationContainer = () => {
  const isAdmin = !!isAdminSite();

  if (isAdmin) {
    return <AdminNavigation />;
  }

  return <LearnerNavigation />;
};

export default NavigationContainer;
